/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any): any => ({
  // 제품 URL 변경
  async update(data?: any) {
    return camelize(
      await $axios.patch(`/sns/product/${data.postingId}`, snakelize(data))
    );
  },

  async deleteImage(data?: any) {
    return camelize(
      await $axios.delete(
        `/sns/product/image/${data.url}`,
        snakelize({ data: data })
      )
    );
  },
});
